export const redirectTo = (pathname: string): void => {
  window.location.assign(pathname)
}

export const redirectToLogout = (env: { [key: string]: string | undefined }): void =>
  redirectTo(`${env.REACT_APP_LOGOUT_URL}`)
